(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mcp-newsletter"]) return;
  try {
    
  // get DOM Elements
  let newsletterFormWrapper = document.querySelector(".mcp-newsletter-form__wrapper");
  let formSignupInputWrapper = document.querySelector(".mcp-newsletter-form-content");
  let secondStepThankYouMessage = document.querySelector(".mcp-newsletter-form_thank-you");
  let newsletterFormOverlay = document.querySelector(".mcp-newsletter-form-overlay");
  let closeBtn = document.querySelector(".mcp-newsletter-form__wrapper .mcp-close-button");
  let formElement = document.querySelector("#mcp-newsletter-signup-form");
  let copyBtn = document.querySelector(".ecomsend__Input_CopyBtn");
  let inputToCopy = document.querySelector(".ecomsend__Input__Input");
  let discoverBtn = document.querySelector(".ecomsend__Button");
  
  // attach event listeners
  closeBtn.addEventListener("click", closeForm);
  formElement.addEventListener("submit", setupSecondStep);
  newsletterFormOverlay.addEventListener("click", closeForm);

  // Add a mouseover event listener
  discoverBtn.addEventListener('mouseover', function() {
    // Change the cursor to pointer
    discoverBtn.style.cursor = 'pointer';
  });
  
  // Add a mouseout event listener to revert the cursor back
  discoverBtn.addEventListener('mouseout', function() {
    // Revert the cursor to its default state
    discoverBtn.style.cursor = 'auto';
  });
  
  // functions
   window.mcpShowPopup = function() {
      let windowWidth = window.innerWidth;
  
      if (windowWidth <= 500) {
        // Center the form on small screens
        newsletterFormWrapper.style.right = "calc(50% - 304px)";
      } else {
        // Show on the right for larger screens
        newsletterFormWrapper.style.right = "-120px";
      }
  
      newsletterFormWrapper.style.visibility = "visible";
      newsletterFormWrapper.style.opacity = "1";
      newsletterFormOverlay.style.display = "block";
    };

  function closeForm() {
    newsletterFormWrapper.style.right = "-500px";
    newsletterFormWrapper.style.visibility = "hidden";
    newsletterFormWrapper.style.opacity = "0";
    newsletterFormOverlay.style.display = "none";
    
    // Remove isMCFormSubmitted once the second step content shown
    const isMCLocalStorageExist = localStorage.getItem("isMCFormSubmitted");
    const storedDataString = localStorage.getItem('mcPopupConfig');
    
    if (isMCLocalStorageExist && isMCLocalStorageExist === "true") {
      localStorage.removeItem("isMCFormSubmitted");
    }

  }

  function setupSecondStep() {
    localStorage.setItem("isMCFormSubmitted", "true");  
  }

  function changeHref() {
    window.location.href = ""
  }

  copyBtn.addEventListener("click", function() {
    const inputValue = inputToCopy.value;
    const tempTextarea = document.createElement("textarea");
    document.body.appendChild(tempTextarea);
    tempTextarea.select();
    tempTextarea.setSelectionRange(0, 99999); // For mobile devices
    document.execCommand("copy");
    document.body.removeChild(tempTextarea);
    const firstSvg = copyBtn.querySelector("svg:first-of-type");
    const secondSvg = copyBtn.querySelector("svg:last-of-type");
  
    firstSvg.style.display = "none";
    secondSvg.style.display = "block";
  
    setTimeout(function() {
      secondSvg.style.display = "none";
      firstSvg.style.display = "block";
    }, 3000);
  });

  
  // check if isMCFormSubmitted is available and true 
  
  function initMCPCheck() {
    const stepTwoTitle = document.querySelector(".mcp-newsletter-form_thank-you-header h2");
    const stepTwoSubtitle = document.querySelector(".mcp-newsletter-form_thank-you-header p");
    const stepTwoDiscountInput = document.querySelector(".mcp-newsletter-form_thank-you-body .ecomsend__Input__Input");
    const stepTwoDiscoverBtn = document.querySelector(".mcp-newsletter-form_thank-you-body .ecomsend__Button");
    
    const storedDataString = localStorage.getItem('mcPopupConfig');
    const storedData = JSON.parse(storedDataString);
    if(storedData) {
      stepTwoTitle.innerText = storedData.stepTwoTitle;
      stepTwoSubtitle.innerText = storedData.stepTwoSubtitle;
      stepTwoDiscountInput.value = storedData.stepTwoDiscountcode;
      stepTwoDiscoverBtn.innerText = storedData.stepTwoCTAText;
      stepTwoDiscoverBtn.href = storedData.stepTwoCTAUrl;
    }
    
    const isMCLocalStorageAvailable = localStorage.getItem("isMCFormSubmitted")
    if (isMCLocalStorageAvailable === "true" && !window.location.href.includes("challenge#mcp-newsletter-signup-form")) {
      formSignupInputWrapper.style.display = "none";
      secondStepThankYouMessage.style.display = "block";
      mcpShowPopup();
    }
  }

  // call initMCPCheck function to check if form has submitted or not

  initMCPCheck();
  

  } catch(e) { console.error(e); }
})();
})();
